export enum ROUTES {
  WEB = 'web',
  WELCOME = 'welcome',
  WELCOME_ONBOARDING = 'welcome_onboarding',
  WELCOME_ONBOARDING_WEB = 'welcome_onboarding_web',
  ONBOARDING = 'onboarding',
  HOME = 'home',
  READ = 'read',
  LISTEN = 'listen',
  WATCH = 'watch',
  IMMERSRSIVE_NEWS_ARTICLE = 'immersive_news_article',
  PROFILE = 'profile',
  LOGIN = 'login',
  PERSONALIZATION = 'personalization',
  SETTINGS = 'settings',
  TBD = 'tbd',
  FAQ = 'faq',
  TERMS = 'terms',
  PRIVACY = 'privacy',
  CONTACT_US = 'contact_us',
  RADIO_PLAYER = 'radio_player',
  CREATE_COLLECTION = 'create_collection',
  EDIT_COLLECTION = 'edit_collection',
  RECOMMENDED_COLLECTIONS = 'recommended_collections',
}
